import { createTheme } from "@mui/material";
import darkTheme from "./darkTheme"
import lightTheme from "./lightTheme"

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    customBackground?: Palette['primary'];
    customText?: Palette['primary'];
    customBorder?: Palette['primary'];
    textFieldColors?: Palette['primary'];
  }
  interface PaletteOptions {
    customBackground?: PaletteOptions['primary'];
    customText?: PaletteOptions['primary'];
    customBorder?: PaletteOptions['primary'];
    textFieldColors?: PaletteOptions['primary'];
  }
}

const themes = {
  dark: darkTheme,
  light: lightTheme,
  default: darkTheme
}

const getTheme = (param: string | undefined) => {
  if (!param) return createTheme(themes.default);
  const themeSelected = themes[param] || themes.default;
  return createTheme(themeSelected)
}

export default getTheme;
